import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  GetPackageSizesSuggestionResp,
  PackageSizeDto,
  PackageSizeModel,
  PackageSizesResp,
  ParcelMeasurementsDto,
  ParcelMeasurementsModel,
} from '../types/package-size'

export const transformPackageSizeDto = ({
  code,
  name,
  description,
  education_text,
  id,
  standard,
  title,
}: PackageSizeDto): PackageSizeModel => ({
  code,
  name,
  description,
  educationText: education_text,
  id,
  standard,
  title,
})

export const transformGetPackageSizesSuggestionResponse = (
  response: Response<GetPackageSizesSuggestionResp>,
) => ({
  packageSizeId: response.package_size_id,
})

export const transformParcelMeasurementsDto = (
  response: ParcelMeasurementsDto,
): ParcelMeasurementsModel => ({
  enabled: response.enabled,
  suggestion: response.suggestion,
  imageName: response.image_name,
  weightUnit: response.weight_unit,
  dimensionUnit: response.dimension_unit,
})

export const transformPackageSizesResponse = (response: Response<PackageSizesResp>) => ({
  packageSizes: response.package_sizes.map(transformPackageSizeDto),
  parcelMeasurements: transformParcelMeasurementsDto(response.parcel_measurements),
})
